import predictionsSlice from '../reducers/predictions.reducer';
import { IEvent } from '../../Types/Event';
import { IResource } from '../../Types/Resource';
import { IRawEvent } from '../../Types/DoyPrediction';

export interface IPredictionsState {
  resources: IResource[],
  events: IEvent[],
  raw: IRawEvent[],
  loading: boolean,
  error: string | null,
}

export const predictionsActions = predictionsSlice.actions;
